/* The Mora Gold House – shared product page helpers: money format, add to cart (opens the MGH cart drawer), lightbox. */
(function () {
  if (window.MGHP) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  root = root.replace(/\/?$/, '/');

  function money(cents, format) {
    cents = Number(cents) || 0;
    format = format || '${{amount}}';
    function fmt(n, d, ts, ds) {
      ts = ts == null ? ',' : ts; ds = ds == null ? '.' : ds;
      var p = (n / 100).toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return p.join(ds);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2);
      }
    }).replace(/<[^>]*>/g, '');
  }

  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    var oc = document.getElementById('cartOffCanvas');
    if (oc && window.bootstrap && bootstrap.Offcanvas) {
      bootstrap.Offcanvas.getOrCreateInstance(oc).show();
    } else {
      window.location.href = root + 'cart';
    }
  }

  /* One request at a time per button; resolves with the added line(s) or rejects with Shopify's message. */
  function addToCart(items, opts) {
    opts = opts || {};
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Error');
        return d;
      });
    }).then(function (d) {
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('.open-cart-drawer a > span:last-child').forEach(function (e) {
            e.innerHTML = '<span class="cart_count_items"> ' + c.item_count + ' </span>';
          });
        }).catch(function () {});
      if (opts.open !== false) openCart();
      return d;
    });
  }

  /* Lightbox: open(list of {src, alt}, index, opener) */
  var lb, lbImg, lbFig, lbCap, lbList = [], lbIdx = 0, lbOpener = null;
  function buildLb() {
    lb = document.createElement('dialog');
    lb.className = 'mgh-lb';
    lb.setAttribute('aria-label', 'Image viewer');
    lb.innerHTML =
      '<button type="button" class="mgh-lb__btn mgh-lb__close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
      '<button type="button" class="mgh-lb__btn mgh-lb__prev" aria-label="Previous image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<figure class="mgh-lb__fig"><img alt=""></figure>' +
      '<button type="button" class="mgh-lb__btn mgh-lb__next" aria-label="Next image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<p class="mgh-lb__cap" aria-live="polite"></p>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('img'); lbFig = lb.querySelector('.mgh-lb__fig'); lbCap = lb.querySelector('.mgh-lb__cap');
    lb.querySelector('.mgh-lb__close').addEventListener('click', function () { lb.close(); });
    lb.querySelector('.mgh-lb__prev').addEventListener('click', function () { show(lbIdx - 1); });
    lb.querySelector('.mgh-lb__next').addEventListener('click', function () { show(lbIdx + 1); });
    lbImg.addEventListener('click', function (e) {
      var on = lbFig.classList.toggle('is-zoom');
      if (on) pan(e);
    });
    lbFig.addEventListener('pointermove', function (e) { if (lbFig.classList.contains('is-zoom')) pan(e); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(lbIdx - 1);
      if (e.key === 'ArrowRight') show(lbIdx + 1);
    });
    lb.addEventListener('close', function () {
      lbFig.classList.remove('is-zoom');
      document.documentElement.style.overflow = '';
      if (lbOpener && lbOpener.focus) lbOpener.focus();
    });
  }
  function pan(e) {
    var r = lbFig.getBoundingClientRect();
    lbImg.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
    lbImg.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
  }
  function show(i) {
    if (!lbList.length) return;
    lbIdx = (i + lbList.length) % lbList.length;
    lbFig.classList.remove('is-zoom');
    lbImg.src = lbList[lbIdx].src;
    lbImg.alt = lbList[lbIdx].alt || '';
    lbCap.textContent = lbList.length > 1 ? (lbIdx + 1) + ' / ' + lbList.length : '';
    var multi = lbList.length > 1;
    lb.querySelector('.mgh-lb__prev').hidden = !multi;
    lb.querySelector('.mgh-lb__next').hidden = !multi;
  }
  function openLightbox(list, index, opener) {
    if (!list || !list.length) return;
    if (!lb) buildLb();
    lbList = list; lbOpener = opener || document.activeElement;
    show(index || 0);
    document.documentElement.style.overflow = 'hidden';
    if (lb.showModal) lb.showModal(); else lb.setAttribute('open', '');
    lb.querySelector('.mgh-lb__close').focus();
  }

  window.MGHP = { money: money, addToCart: addToCart, openCart: openCart, lightbox: openLightbox, root: root };
  /* Prices written by the product section before this file loaded come out as bare numbers (e.g. 6980.00): format them with the store currency. */
  document.querySelectorAll('[data-mgh-pdp]').forEach(function (r) {
    var f = r.dataset.money;
    r.querySelectorAll('[data-price],[data-compare],[data-sticky-price]').forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (/^[0-9]+(\.[0-9]{1,2})?$/.test(t)) el.textContent = money(Math.round(parseFloat(t) * 100), f);
    });
  });
})();
